export default {
    namespaced: true,
    state: (): { actions: any[] } => ({
        actions: []
    }),
};